import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';
import { UserService } from '@app/services/user.service';
import { Subscription } from 'rxjs';
import { LoginComponent } from '@app/components/account/login/login.component';
import { UserModel } from '@app/models/user/user.model';
import { AppConfig } from '@app/app.config';

@Component({
  selector: 'app-main-account-links',
  templateUrl: './main-account-links.component.html',
  styleUrls: ['./main-account-links.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainAccountLinksComponent implements OnInit, OnDestroy {
  locale: any = {};
  showDropdown: boolean = false;
  currentUser: UserModel = new UserModel();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private userService: UserService,
    private localisation: LocalisationService
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('MainNavComponent');

    this.userService.getUser().subscribe(user => {
      this.currentUser = user;
    });
  }

  ngOnDestroy(): void {}

  signOut() {
    this.authService.logout();
    this.router.navigate([`/${LoginComponent.route}`]);
  }

  toggleAccountDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  goToMyFJ() {
    window.location.href = AppConfig.MyFJUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/main-account-links/main-account-links.component.ts